// extracted by mini-css-extract-plugin
export default {"footer":"org_footer__QghrU"};